import { ReactElement } from 'react'

import classNames from 'classnames'
import { getIn } from 'formik'

import { UtcDatePicker } from 'components/UtcDatePicker/UtcDatePicker'
import { date, type ConfigType } from 'configuration/dayjs'

import { FormikWithCustomHandlersProps } from '../propTypes'
import withCustomHandlers from '../withCustomHandlers'

type FormikDatePickerProps<V> = FormikWithCustomHandlersProps<V> & {
    minDate: ConfigType
    maxDate?: ConfigType
}

function FormikDatePicker<V>({
    field: { value, name },
    form,
    handleChange,
    handleBlur,
    handleClick,
    minDate,
    maxDate,
    ...props
}: FormikDatePickerProps<V>): ReactElement {
    return (
        <UtcDatePicker
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            disabledDate={(current) =>
                !!current &&
                ((!!minDate && current.isBefore(date(minDate), 'day')) ||
                    (!!maxDate && current.isAfter(date(maxDate), 'day')))
            }
            className={classNames({
                'fg-control-error':
                    getIn(form.errors, name) && getIn(form.touched, name),
            })}
            {...props}
        />
    )
}

export default withCustomHandlers(FormikDatePicker)
